import httpClient from '../httpClient';

const getAllByValidation = async (id) => {
  return await httpClient.get(
    `/term_document_validation_history/?filter[validacion_documentos]=${id}`,
  );
};

export { getAllByValidation };
